export const DEFAULT_BACKFILL_DAYS_CUSTOM_OPTION = -1;

export const DEFAULT_BACKFILL_DAYS_OPTIONS = [
  30,
  90,
  180,
  DEFAULT_BACKFILL_DAYS_CUSTOM_OPTION,
];
